import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { EventsSchema } from "../../../schemas/events";
import { wsManager } from "../websocket/WebSocketManager";

export function useEventsWebSocket() {
  const queryClient = useQueryClient();
  const router = useRouter();

  useEffect(() => {
    // Create connection with error handling
    const connection = wsManager.getConnection("events", {
      url: `${window.location.origin}/api/events/ws`,
      onError: (error) => {
        console.error("[WebSocket] Error:", error);
        // Don't throw here, let the connection manager handle reconnection
      },
      onClose: () => {
        console.log("[WebSocket] Connection closed");
      },
      onOpen: () => {
        console.log("[WebSocket] Connection opened");
      },
    });

    const removeHandler = connection.addMessageHandler(async (event) => {
      try {
        const data = JSON.parse(event.data);
        const eventData = EventsSchema.parse(data);

        try {
          switch (eventData.type) {
            case "chat.created":
            case "chat.updated":
              // Invalidate both query cache and router loader
              await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["CHATS"] }),
                router.invalidate(),
              ]);
              break;
            case "chat.deleted":
              // For deletions, we want to ensure the data is removed from cache
              await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["CHATS"] }),
                queryClient.invalidateQueries({
                  queryKey: ["CHATS", eventData.chatId],
                }),
                router.invalidate(),
              ]);
              break;
          }
        } catch (error) {
          console.error("[useEventsWebSocket] onMessage handler error:", error);
        }
      } catch (error) {
        // Only log parsing errors, don't throw
        console.error("[useEventsWebSocket] Failed to parse message:", error);
      }
    });

    // Connect the WebSocket
    connection.connect();

    return () => {
      // Only remove the handler, don't remove the connection
      // This allows the WebSocket to stay open between Strict Mode mounts
      removeHandler();
    };
  }, [queryClient, router]);
}
